import { Ye as l, p as c, b as u } from "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
import { t as p } from "./beacon-primitive-ChVMWFlW-Df2Js5lw.js";
import { a as h } from "./uid-HAKIZOcY-BMoifg7G.js";
var g = Object.defineProperty, n = (a, i, o, e) => {
  for (var t = void 0, r = a.length - 1, s; r >= 0; r--)
    (s = a[r]) && (t = s(i, o, t) || t);
  return t && g(i, o, t), t;
};
const m = "beacon-table";
class d extends p(c) {
  constructor() {
    super(...arguments), this.isOriginal = !0, this.uuid = h();
  }
  /** When using transformed cards, this stores all nodes associated with the current one via their identical UUID. */
  get pairedNodes() {
    const { beaconTagName: i, uuid: o } = this, e = `[uuid="${o}"]`, t = `${this.getScopedTagName(i)}${e}`;
    if (this.isOriginal) {
      const r = this.closest(this.getScopedTagName(m));
      if (!r)
        return;
      const s = r.transformedCardsContainer;
      return s ? s.querySelectorAll(t) : void 0;
    }
    return document.querySelectorAll(t);
  }
  willUpdate(i) {
    i.forEach((o, e) => {
      var t;
      this.pairedNodes && e !== "isOriginal" && (!this.isOriginal && e === "bold" || (t = this.pairedNodes) == null || t.forEach((r) => {
        r[e] = this[e];
      }));
    });
  }
}
n([
  l()
], d.prototype, "isOriginal");
n([
  u({ reflect: !0 })
], d.prototype, "uuid");
export {
  d
};
